import { IconArticle, IconFlag, IconCards, IconBooks, IconPaperclip } from "../icons/icons";
/**
 * arreglo con todos las listas de lecturas
 */
export const READING_LISTS = [
    {
        id: 'Materias',
        type: 'listas',
        name: {
            defaultValue: 'Materias',
            translationPath: 'content.seccion.titulo.materias'
        },
        icon: IconArticle,
        classIcon: "icon-article",
        pathname: '/curadurias/materias',
        search: '?page=1',
    },
    {
        id: 'Paises',
        type: 'listas',
        name: {
            defaultValue: 'Países',
            translationPath: 'content.seccion.curadurias.paises'
        },
        icon: IconFlag,
        classIcon: "icon-flag",
        pathname: '/curadurias/paises',
        search: '?page=1',
    },
    {
        id: 'Colecciones',
        type: 'listas',
        name: {
            defaultValue: 'Colecciones',
            translationPath: 'content.seccion.curadurias.colecciones'
        },
        icon: IconCards,
        classIcon: "icon-cards",
        pathname: '/curadurias/colecciones',
        search: '?page=1',
    },
    {
        id: 'Editoriales',
        type: 'listas',
        name: {
            defaultValue: 'Editoriales',
            translationPath: 'content.seccion.curadurias.editoriales'
        },
        icon: IconBooks,
        classIcon: "icon-books",
        pathname: '/curadurias/editoriales',
        search: '?page=1',
    },
    {
        id: 'libros-guias',
        type: 'listas',
        name: {
            defaultValue: 'Libros con guías',
            translationPath: 'content.seccion.curadurias.guias'
        },
        icon: IconPaperclip,
        classIcon: "icon-paperclip",
        pathname: '/busqueda',
        search: '?actividad=1?page=1',
    },

]